import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

// Component
import { EmojiButtonComponent } from './components/emoji-button.component';
import { EmojiContentComponent } from './components/emoji-content.component';
import { EmojiPickerComponent } from './components/emoji-picker.component';
import { EmojiHeaderComponent } from './components/emoji-header.component';
import { EmojiListComponent } from './components/emoji-list.component';
import { EmojiCategoriesComponent } from './components/emoji-categories.component';
import { EmojiSearchComponent } from './components/emoji-search.component';
import { EmojiCategoryComponent } from './components/emoji-category.component';
import { EmojiFooterComponent } from './components/emoji-footer.component';


//
import { EmojiPickerCaretDirective } from './directives/emoji-picker-caret.directive';
import { EmojiPickerApiDirective } from './directives/emoji-picker-api.directive';


import { EmojiEmptyCategoryPipe } from './pipes/emoji-empty-category.pipe';

import { EmojiPickerOptions } from './services/emoji-picker.service';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    // Directives
    EmojiPickerApiDirective,
    EmojiPickerCaretDirective,
    // Components
    EmojiButtonComponent,
    EmojiContentComponent,
    EmojiPickerComponent,
    EmojiListComponent,
    EmojiHeaderComponent,
    EmojiSearchComponent,
    EmojiCategoriesComponent,
    EmojiCategoryComponent,
    EmojiFooterComponent
  ],
  declarations: [
    EmojiEmptyCategoryPipe,
    // Directives
    EmojiPickerApiDirective,
    EmojiPickerCaretDirective,
    // Components
    EmojiButtonComponent,
    EmojiContentComponent,
    EmojiPickerComponent,
    EmojiListComponent,
    EmojiHeaderComponent,
    EmojiSearchComponent,
    EmojiCategoriesComponent,
    EmojiCategoryComponent,
    EmojiFooterComponent
  ],
  providers: [],
  entryComponents: [EmojiPickerComponent]
})
export class EmojiPickerModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: EmojiPickerModule,
      providers: [
        EmojiPickerOptions
      ]
    }
  }
}
